/**
 * The inputs and cache options of every query v2 Home prefetches for the
 * other v2 pages (useV2HomePrefetch). The page hooks build their inputs
 * HERE too, so a prefetch and the page's own read share one React Query key
 * and cannot drift (proof: useV2HomePrefetch.test.tsx).
 *
 * Only Postgres-backed reads belong here. Anything that reaches Snowflake,
 * live Mirakl, Rithum or another external service is NOT prefetched: a
 * background warm-up multiplied by every Home visit is load the user never
 * asked for (precedent: a prewarm cron once saturated Nordstrom's Mirakl
 * quota). The excluded list, with reasons, is V2_PREFETCH_EXCLUDED in
 * components/v2/home/useV2HomePrefetch.ts.
 */

/** Five minutes: the staleTime every page hook below already uses. */
export const PAGE_STALE_MS = 5 * 60 * 1000;

/** `mirakl.cohortReturnRate` (Returns): Postgres Mirakl copy. `brandId` is required by the schema. */
export const cohortReturnRateInput = (brandId: number) => ({ brandId });

/** `finances.getOpenDiscrepancyCount` (Finances): Postgres. */
export const openDiscrepancyCountInput = (brandId?: number | null) => ({ ...(brandId ? { brandId } : {}) });

/** `exports.capabilities` and `exports.schedules.list` (Reports library): Postgres + env config. */
export const exportsBrandInput = (brandId: number | undefined) => ({ brandId });

/** `exports.capabilities` cache window (Reports library, Settings > Data exports). */
export const EXPORTS_CAPABILITIES_STALE_MS = 30 * 1000;

/** `hub.listPages` (Reports library, Hub brands only): Postgres. */
export const hubPagesInput = (brandId: number | null) => ({ brandId: brandId ?? undefined });

/** `productsPage.lastAsn` (Products): Postgres `asn` table. */
export const lastAsnInput = (brandId: number | undefined) => ({ brandId });

/** `productsPage.lastAsn` cache window (and no retries: a failed read only hides the line). */
export const LAST_ASN_STALE_MS = 60_000;

/** `productsPage.getLeadTime` (Products > Next shipment, Settings > Profile): Postgres. */
export const leadTimeInput = (brandId?: number | null) => ({ ...(brandId ? { brandId } : {}) });

/** `promotions.calendar` (Products > All products): Postgres Mirakl copy. */
export const promotionCalendarInput = (brandId?: number | null) => (brandId != null ? { brandId } : {});
